import React, { useState, useEffect, useRef, useCallback } from "react";
import { useExamStatus } from "../ExamStatusContext";
import { useScoreTable } from "../ScoreContext";
import withResetOnNavigation from '../withResetOnNavigation';
import questions from "../QA/Test7_q_a";
import TestContainer from "../TestContainer";
import ZoomControls from "../ZoomControls";
import "../../../css/test7.css";
import "../../../css/examplequestion.css";

const Test7 = ({ onNext }) => {
  const { examStatus } = useExamStatus();
  const [inputValues, setInputValues] = useState({});
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [isTest7Started, setIsTest7Started] = useState(false);
  const [notification, setNotification] = useState("");
  const [isTimeUp, setIsTimeUp] = useState(false);
  const score7 = useRef(0);
  const inputRefs = useRef([]);
  const scoreTable = useScoreTable();

  const testDuration = 120;

  const exampleQuestions = [
    { question: "28 + 7 = ", answer: 35 },
    { question: "90 - 72 = ", answer: 18 },
    { question: "28 × 3 = ", answer: 84 },
    { question: "72 ÷ 6 = ", answer: 12 },
  ];

  useEffect(() => {
    const test7Status = localStorage.getItem("test7Status");
    if (examStatus === "検査中" && test7Status === "started") {
      localStorage.setItem("test7Status", "notStarted");
    }
  }, [examStatus]);

  const gradeTest = useCallback(() => {
    let calculatedScore = 0;

    questions.forEach((question, index) => {
      const userAnswer = parseInt(inputValues[index], 10);
      if (userAnswer === question.answer) {
        calculatedScore += 1;
      }
    });

    score7.current = calculatedScore;
    localStorage.setItem("score7", calculatedScore);

    const normalizedScore = scoreTable.scoreTable7[String(calculatedScore)] ?? 0;
    const currentNScore = parseInt(localStorage.getItem("N_score"), 10) || 0;
    localStorage.setItem("N_score", currentNScore + normalizedScore);

    setNotification("検査を終了します！");
    setIsTimeUp(true);

    if (onNext) onNext(); // ← 次へ進む
  }, [inputValues, scoreTable.scoreTable7, onNext]);

  const handleStartTest = () => {
    setIsTest7Started(true);
    localStorage.setItem("test7Status", "started");
  };

  const handleInputChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");

    setInputValues((prev) => ({
      ...prev,
      [index]: value,
    }));

    if (value !== "" && index === currentQuestionIndex) {
      setCurrentQuestionIndex((prev) => prev + 1);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Enter" && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  if (!isTest7Started) {
    return (
      <div className="test7-container">
        <h1>検査5 - やり方の説明</h1>
        <p>
          各問題で計算問題を行って下さい。
          <br />
          解答は半角数字で入力してください。
        </p>
        <h2>例題</h2>
        <div className="example-container">
          <div className="example-questions">
            {exampleQuestions.map((example, index) => (
              <div key={index} className="test7-question">
                <span className="test7-word">{example.question}</span>
                <input
                  type="text"
                  value={example.answer}
                  readOnly
                  className="test7-input example"
                />
              </div>
            ))}
          </div>
        </div>
        <button className="start-button" onClick={handleStartTest}>
          検査に進む
        </button>
      </div>
    );
  }

  const renderedQuestions = questions
    .slice(0, currentQuestionIndex + 1)
    .map((question, index) => (
      <div key={question.id} className="test7-question">
        <p>問題 {index + 1}</p>
        <span className="test7-word">{question.question}</span>
        <input
          ref={(el) => (inputRefs.current[index] = el)}
          type="text"
          value={inputValues[index] || ""}
          onChange={(e) => handleInputChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          placeholder="解答を入力"
          className="test7-input"
        />
      </div>
    ));

  return (
    <ZoomControls>
      <TestContainer
        title="検査5"
        isTimeUp={isTimeUp}
        notification={notification}
        renderedQuestions={renderedQuestions}
        manageTimer={true}
        gradeTest={gradeTest}
        testDuration={testDuration}
      />
    </ZoomControls>
  );
};

export default withResetOnNavigation(Test7);
